var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWhats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86761 19.9865L4.17061 20.4372C4.00242 20.4653 3.83103 20.4104 3.71047 20.2898C3.5899 20.1692 3.53501 19.9978 3.56311 19.8296L4.01371 17.1325C1.38201 13.0424 2.25745 7.62611 6.04367 4.57331C9.82989 1.52052 15.3086 1.81347 18.7477 5.25261C22.1868 8.69175 22.4797 14.1705 19.4268 17.9567C16.374 21.7428 10.9577 22.6182 6.86761 19.9865Z",
    fill: "#00C451",
    stroke: "#00C451",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9273 10.9315C11.4642 11.8027 12.1975 12.536 13.0687 13.0729L13.8905 12.5798C14.2489 12.3647 14.7033 12.3953 15.0297 12.6564L16.6248 13.9325C16.8481 14.1111 16.9843 14.3768 16.9989 14.6623C17.0135 14.9479 16.9051 15.226 16.7012 15.4265L15.9801 16.1355C14.9868 17.115 13.4496 17.2808 12.2702 16.5358C10.3466 15.2916 8.70863 13.6536 7.46443 11.73C6.71935 10.5506 6.88522 9.01332 7.86473 8.02002L8.57373 7.29891C8.77418 7.09503 9.05233 6.9867 9.33788 7.00131C9.62343 7.01591 9.88907 7.15205 10.0677 7.37532L11.3438 8.97044C11.6049 9.29684 11.6354 9.7512 11.4204 10.1096L10.9273 10.9315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWhats);
export default __webpack_public_path__ + "static/media/green-whats.99df4244abb24a35fb852301d59e8837.svg";
export { ForwardRef as ReactComponent };